import styled, { keyframes } from 'styled-components';
import React from 'react';

const aniLoading = keyframes`
  0%, 80%, 100% {
      transform: scale(0.0);
      -webkit-transform: scale(0.0);
  }
  40% {
      transform: scale(1.0);
      -webkit-transform: scale(1.0);
  }
`;

type IProps = {
  dark?: boolean;
  page?: boolean;
};

const Wrap = styled.div
  .withConfig({
    shouldForwardProp: (props) => {
      return !['dark', 'page'].includes(props);
    },
  })
  .attrs<IProps>((props: IProps) => ({
    className: `${props.dark ? 'dark' : ''} ${props.page ? '_page' : ''}`,
  }))`
  margin: 0 auto 10px;
  text-align: center;
  //height: 64px;
  padding: 20px 0;

  &._page {
    padding: 200px 0;
  }

  & > div {
    width: 20px;
    height: 20px;
    background-color: ${(props) => props.theme.color.grayLighter};
    border-radius: 100%;
    margin: 0 10px;
    display: inline-block;
    animation: ${aniLoading} 1.4s infinite ease-in-out;
    animation-fill-mode: both;
  }

  &.dark {
    & > div {
      background-color: ${(props) => props.theme.color.grayLight};
    }
  }

  .bounce1 {
    animation-delay: -0.32s !important;
  }

  .bounce2 {
    animation-delay: -0.16s !important;
  }
`;

const Index: React.FC = (props: IProps) => {
  return (
    <Wrap {...props}>
      <div className="bounce1" />
      <div className="bounce2" />
      <div className="bounce3" />
    </Wrap>
  );
};

export default Index;
